import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import { Permission } from "callable-data-objects/dist/models/role";
import { CallableInput } from "Components/Shared";
import { FastField, Formik } from "formik";
import { useRole } from "Hooks/Endpoints";
import React from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Form,
  Header,
  Label,
  Menu,
  Segment,
  Table,
} from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";

const RoleDetails = () => {
  const {
    role,
    updateRole,
    assignPermission,
    revokePermission,
    unselectRole,
    permissions,
  } = useRole();

  const connected = (id: string) => {
    return (
      role.permissions?.find((p: DBReference) => p.id === id) !== undefined
    );
  };

  const getColor = (id: string): SemanticCOLORS => {
    return connected(id) ? "red" : "blue";
  };

  return (
    <Container fluid>
      <Menu>
        <Menu.Item>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={unselectRole}>
              Roles
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>{role.name}</Breadcrumb.Section>
          </Breadcrumb>
        </Menu.Item>
      </Menu>
      <Segment>
        <Formik
          validateOnChange={true}
          initialValues={role}
          onSubmit={(values, actions) => {
            updateRole(values);
          }}
        >
          {({ handleSubmit, setFieldValue, errors, validateField }) => (
            <Form onSubmit={handleSubmit}>
              <FastField
                name='name'
                label='Name'
                disabled={true}
                component={CallableInput}
              />

              <FastField
                name='description'
                label='Description'
                disabled={true}
                component={CallableInput}
              />
            </Form>
          )}
        </Formik>
      </Segment>
      <Segment>
        <Header as='h5'>Permissions</Header>
        <Table singleLine stackable padded striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell></Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Description</Table.HeaderCell>
              <Table.HeaderCell>Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {permissions
              .sort((p: Permission, p1: Permission) =>
                p.name.localeCompare(p1.name)
              )
              .map((p: Permission) => (
                <Table.Row key={p.id}>
                  <Table.Cell width={1}>
                    {connected(p.id) ? (
                      <Label color='blue' ribbon>
                        Assigned
                      </Label>
                    ) : (
                      ""
                    )}
                  </Table.Cell>
                  <Table.Cell width={6}>{p.name}</Table.Cell>
                  <Table.Cell width={6}>{p.description}</Table.Cell>
                  <Table.Cell width={2}>
                    <Button
                      color={getColor(p.id)}
                      onClick={() =>
                        connected(p.id)
                          ? revokePermission(p.id)
                          : assignPermission(p.id)
                      }
                    >
                      {connected(p.id) ? "Revoke" : "Assign"}
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Segment>
    </Container>
  );
};

export default RoleDetails;
